import {
  ICyclesListReduxState,
  IGetCyclesListAction,
  IGetCyclesListActionFulfilled,
  IGetCyclesListActionRejected
} from "../../types";
import { GET_CYCLES_LIST, GET_CYCLES_LIST_REJECTED, GET_CYCLES_LIST_FULFILLED } from "../constants";

const initialState: ICyclesListReduxState = {
  completed: false,
  cycles: [],
  pagination: {
    page: 0,
    pageSize: 10,
    totalEntityCount: 0,
    totalPageCount: 0
  },
  pending: false,
  rejected: false
};

type Actions = IGetCyclesListAction | IGetCyclesListActionFulfilled | IGetCyclesListActionRejected;

export default (state = initialState, action: Actions) => {
  switch (action.type) {
    case GET_CYCLES_LIST:
      return {
        ...state,
        completed: false,
        cycles: [],
        pending: true,
        rejected: false
      };
    case GET_CYCLES_LIST_REJECTED:
      return {
        ...state,
        completed: true,
        cycles: [],
        pending: false,
        rejected: true
      };
    case GET_CYCLES_LIST_FULFILLED: {
      const { entities, ...rest } = action.payload;
      return {
        ...state,
        completed: true,
        cycles: entities,
        pagination: {
          ...rest
        },
        pending: false,
        rejected: false
      };
    }
    default:
      return {
        ...state
      };
  }
};
